enum UserMembershipTypeEnum {
  ADMIN = "ADMIN",
  USER = "USER",
  VIEWER = "VIEWER",
}

export default UserMembershipTypeEnum;
